import React, { useMemo, useRef, useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { useResizeDetector } from "react-resize-detector";
const scrollRight = keyframes `
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0%);
  }
`;
const scrollLeft = keyframes `
  0% {
    transform: translateX(0%s);
  }
  100% {
    transform: translateX(-100%);
  }
`;
export const MarqueeContainer = styled.div ``;
export const MarqueeWrapper = styled.div `
  animation: ${({ direction, speed }) => css `
    ${speed}s linear infinite running ${direction === "right" ? scrollRight : scrollLeft}
  `};
  @media (prefers-reduced-motion) {
    animation: ${({ direction, speed }) => css `
      ${speed * 4}s linear infinite running ${direction === "right" ? scrollRight : scrollLeft}
    `};
  }
`;
export const MarqueeElement = styled.div ``;
const multiplyElements = (element, multiplier) => {
    return [...Array(multiplier)].map((el, index) => React.createElement(React.Fragment, { key: `${el}-${index}` }, element));
};
const _Marquee = ({ speed, className, children, direction = "right", ...props }) => {
    const { width: containerWidth, ref: containerRef } = useResizeDetector();
    const marqueeRef = useRef(null);
    const [marqueeWidth, setMarqueeWidth] = useState(0);
    useEffect(() => {
        setMarqueeWidth(marqueeRef?.current?.clientWidth || 0);
    }, []);
    const multiplier = useMemo(() => {
        if (!containerWidth || !marqueeWidth)
            return 10;
        return marqueeWidth < containerWidth ? Math.ceil(containerWidth / marqueeWidth) : 10;
    }, [containerWidth, marqueeWidth]);
    const duration = useMemo(() => {
        if (!marqueeWidth || !containerWidth)
            return;
        return marqueeWidth < containerWidth ? containerWidth / speed : marqueeWidth / speed;
    }, [containerWidth, marqueeWidth, speed]);
    return (React.createElement(MarqueeContainer, { ...props, ref: containerRef, className: className },
        React.createElement(MarqueeWrapper, { speed: duration || 0, ref: marqueeRef, direction: direction }, multiplyElements(React.createElement(MarqueeElement, null, children), multiplier)),
        React.createElement(MarqueeWrapper, { speed: duration || 0, direction: direction }, multiplyElements(React.createElement(MarqueeElement, null, children), multiplier))));
};
export const Marquee = styled(_Marquee) ``;
//# sourceMappingURL=Marquee.js.map